/**
 * If data param is string wil return string, if JSON will parse and return object
 * @param {String} data
 */
export const jsonOrString = (data) => {
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};
